export default __webpack_public_path__ + "48acebf93ba3367745f1623120e6795e.png";